import {InjectionKey} from "vue";

export const DataProviderManageEntityTabInjection = Symbol() as InjectionKey<(p: DataProviderManageEntityTabPayloadInterface) => void>

export interface DataProviderManageEntityTabPayloadInterface {
    entityType: OperatorApplicationApi.OperatorGetParamsIntegrationDataProviderEntityTypeOpenApiModel;
    platform: OperatorApplicationApi.OperatorGetParamsPlatformOpenApiModel;
    integration: OperatorApplicationApi.OperatorGetParamsIntegrationAuthOpenApiModel;
    entityId?: string | number
}